module.exports = __webpack_public_path__ + "static/media/man-woman-vertical.5bab0c08.png";